export const DEFAULT_LADDER = [
  { code: 'CNA', label: 'Certified assistant' },
  { code: 'ADN', label: 'Associate RN' },
  { code: 'BSN', label: 'Bachelor of Science' }
]

export function ladderStepsFromPathway(p) {
  const from = String(p?.from_program?.abbr || p?.from_program?.short || '').trim()
  const to = String(p?.to_program?.abbr || p?.to_program?.short || '').trim()
  const mid = String(p?.mid_program?.abbr || p?.mid_program?.short || '').trim()
  if (from && to && from.toLowerCase() !== to.toLowerCase()) {
    // Optional midpoint earned at the entry school (CNA Prep -> CNA -> ADN).
    if (mid && ![from, to].map(c => c.toLowerCase()).includes(mid.toLowerCase())) return [{ code: from }, { code: mid }, { code: to }]
    return [{ code: from }, { code: to }]
  }
  const title = String(p?.title || '').trim()
  const match = title.match(/^(.{1,28}?)\s+(?:to|→|->)\s+(.{1,28})$/i)
  if (match) return [{ code: match[1].trim() }, { code: match[2].trim() }]
  return null
}
